import { IntRange } from '../utils/typing'
import { AppRegions } from './AppRegions.model'
import { ConditionalStatusGroup } from './ConditionalStatusGroup.model'
import { Difficulties } from './Difficulties.model'
import { Keyword } from './Keyword.model'
import { ManualTrailStatus } from './ManualTrailStatus.model'
import { Sponsor } from './Sponsor.model'
import { TrailFeature } from './TrailFeature.model'
import { TrailStatus } from './TrailStatus.model'
import { TrailSystem } from './TrailSystem.model'
import { TrailWay } from './TrailWay.model'
import { TrailRelation } from './TrailRelation.model'
import { TrailTrailforksLink } from './TrailTrailforksLink.model'
import { ParkingLot } from './ParkingLot.model'
import { USStates } from './USStates.model'
import { WeatherGroup } from './WeatherGroup.model'

export type Trail = {
  id: number
  region: AppRegions
  name: string
  system?: TrailSystem
  weatherGroups: (WeatherGroup & { priority: number })[]
  displayWeatherGroup?: WeatherGroup
  manualTrailStatuses?: ManualTrailStatus[]
  conditionalStatusGroups?: ConditionalStatusGroup[]
  ways: TrailWay[]
  osmRelations: TrailRelation[]
  // Optional so callers can distinguish "relation not loaded on this search" (undefined)
  // from "loaded but empty" ([]) — the chip and CSV export rely on this distinction.
  trailforksIds?: TrailTrailforksLink[]
  sponsor?: Sponsor
  features?: TrailFeature[]
  status?: TrailStatus
  difficultyId: Difficulties
  description: string
  featuredImgUrl: string
  surfaceType: string
  distance: number
  descent: number
  climb: number
  gpsLat: number
  gpsLong: number
  parkingGpsLat: number
  parkingGpsLong: number
  parkingLotId?: number | null
  parkingLot?: ParkingLot | null
  street: string
  city: string
  state: USStates
  weatherResistance: IntRange<1, 21>
  // Nullable: an unset trail inherits its system's saturationModifier (trail > system > 1).
  saturationModifier?: number | null
  freezeModifier: number
  thawModifier: number
  dryTimeModifier: number | null
  sortWeight: number
  permalink: string
  keywords?: Keyword[]
  active: boolean
  updatedAt: Date
  createdAt: Date
  precipitationLookbackDays?: number | null
  freezeThawEnabled?: boolean | null
  // Trailforks status pusher (Trailforks-Pusher-Spec.md). Tri-state: null = inherit
  // from system, true = explicitly on for this trail, false = explicitly off.
  trailforksSyncEnabled?: boolean | null
}

// we offer this to enable the enumerate the Trail type's fields in js/ts files
export const trailFields: (keyof Trail)[] = [
  'id',
  'region',
  'name',
  'system',
  'weatherGroups',
  'displayWeatherGroup',
  'manualTrailStatuses',
  'conditionalStatusGroups',
  'ways',
  'features',
  'difficultyId',
  'description',
  'featuredImgUrl',
  'surfaceType',
  'distance',
  'descent',
  'climb',
  'gpsLat',
  'gpsLong',
  'parkingGpsLat',
  'parkingGpsLong',
  'parkingLotId',
  'parkingLot',
  'street',
  'city',
  'state',
  'weatherResistance',
  'saturationModifier',
  'freezeModifier',
  'thawModifier',
  'dryTimeModifier',
  'sortWeight',
  'permalink',
  'keywords',
  'active',
  'updatedAt',
  'createdAt',
  'precipitationLookbackDays',
  'freezeThawEnabled',
  'trailforksSyncEnabled',
]
